import { AppLayout } from "../shared";
import UsersDirectory from "../MasterOrg/UsersDirectory";

const MasterOrgUsers_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <UsersDirectory props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgUsers_layout;
